import { Navigate } from "react-router-dom"
import { useAppSelector } from "@redux/hooks"

const ProtectedRoute: React.FC<any> = ({ children }) => {
    const { userData } = useAppSelector(s => s.auth)
    
    if (!!userData) return children
    return <Navigate to = "/login" />
}

export default ProtectedRoute